import { InstanceScreen } from 'component/navigation/instance';

export default function EditorialDashboardStoriesScreen() {
    return <InstanceScreen screenKey='stories' />;
}
